import '../styles/Accueil.css';
import img_exListe from '../assets/exListe.jpg';
import Connexion from '../components/Connexion';

function Accueil()
{
  return <div className="container">
      <p className="subtitle">Une plateforme simple et pratique pour enregistrer, organiser et partager toutes tes idées cadeaux.</p>
      
      <ul className="features">
          <li>Ajoute facilement des articles depuis n'importe quel site ou manuellement.</li>
          <li>Organise et gère tes articles en un seul endroit.</li>
          <li>Partage avec tes proches : ta liste pour leur donner des idées.</li>
          <li>Evites les doublons : Permets à tes proches de réserver un article sans te le dire.</li>
      </ul>        
      <p><a href="/register" className="cta-button">Créer ma liste gratuitement</a></p>
      <Connexion/>
      <p>
        {/* <a href="?key=123456789" className="cta-button" target="_blank" >Consulter la liste de démonstration</a> */}
      <a href="?key=987654321" className="cta-button" target="_blank" >Se connecter sur le compte de démonstration</a></p>
      <div className="image-container">
        <img src={img_exListe} alt="Exemple de liste"/>
    </div>
  </div>
}

export default Accueil